const DIVISION = 'division';
const CONFERENCE = 'conference';
const LEAGUE = 'league';

export default {
    DIVISION,
    CONFERENCE,
    LEAGUE
};